import script from "./messageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./messageView.vue?vue&type=script&setup=true&lang=ts"

import "./messageView.vue?vue&type=style&index=0&id=62427a8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62427a8c"]])

export default __exports__